import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import { Input } from "../../../component/form/input";
import LogOut from "../../../component/dashboard/user/logout/logout";
import PageChange from "../../../component/pageChange";
import toast from "react-hot-toast";


function ReChargesAccountPage() {
    var { t } = useTranslation()
    const { login, token, user } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(true);
    const [currentPlanData, setCurrentPlanData] = useState({})
    const [plansData, setPlansData] = useState([])
    const [checkedPriod, setCheckedPriod] = useState("YEARLY");
    const [price, setPrice] = useState([])


    useEffect(() => {
        document.title = "افزایش اعتبار حساب"
        if (!login) {
            window.location.href = '/auth'
        } else {
            // getPlansData()
        }
    }, [])

    // async function getPlansData() {
    //     // توکن ب سرور داده شده و اطلاعات کاربر دریافت
    //     await fetch(`${process.env.REACT_APP_SERVER}/api/billing/plans`, {
    //         method: "GET",
    //         headers: {
    //             Authorization: "ArNew " + token,
    //         },
    //     }).then((res) => {
    //         res
    //             .json()
    //             .then((result) => {
    //                 if (!result.data) {
    //                     LogOut();
    //                     toast.error("شما دسترسی ندارید");
    //                     window.location.href = '/login';
    //                 }
    //                 if (result.status === "success") {
    //                     setIsDataLoad(true)
    //                     setPlansData(result.data.plans)
    //                     setCurrentPlanData(result.data.current)
    //                 } else {
    //                     toast.error(result.msg);
    //                     LogOut();
    //                     window.location.href = '/login';
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.log(error);
    //             });
    //     });
    // }


    // const getPeriodPay = (period) => {
    //     switch (period) {
    //         case "UNLIMITED":
    //             return "نامحدود"
    //         case "MONTHLY":
    //             return "ماهانه"
    //         case "YEARLY":
    //             return "ماهانه"
    //         default:
    //             return "نامشخص"
    //     }
    // }

    const handlePriceChange = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace(/[^0-9]/g, '');
        const formattedValue = formatPrice(inputValue);
        setPrice(formattedValue);
    };

    const formatPrice = (value) => {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };


    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (
                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <h1 className="font-extrabold text-2xl text-start text-black mt-5">افزایش اعتبار «فضای کاری من»</h1>
                        <h4 className="font-normal text-lg text-start text-gray-500 mt-2">در اینجا می توانید اعتبار خود را افزایش دهید</h4>

                        <h4 className="font-normal text-lg text-start text-gray-500 mt-8">اگر کارت هدیه دارید اینجا وارد کنید</h4>
                        <div className="flex">
                            <div className="relative mt-4 w-[300px]">
                                <Input
                                    placeholder={"کد کارت هدیه را اینجا وارد کنید"}
                                    type="text"
                                    id={"gift"}
                                    name={"gift"}
                                    autoComplete={"off"}
                                    requiredir={true}
                                    onChange={(e) => {
                                        // setPhone(e.target.value);
                                    }}
                                />
                                <div className="absolute -mt-10 -left-4">
                                    <button
                                        className="px-5 h-9 text-white bg-blue-500 rounded-lg "
                                        type="submit"
                                    // onClick={() => receiveSMS(phoneSms)}
                                    >
                                        ثبت
                                    </button>
                                </div>
                            </div>
                        </div>


                        <hr className="my-10" />

                        <div className="block p-2 px-2 text-base text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                            <div className="inline-flex items-start justify-start text-start w-full gap-2">
                                <p className="font-normal">اعتبار فعلی شما: </p>
                                <p className="font-bold"> {formatPrice(user.payments.balance.toString())} تومان </p>
                            </div>
                        </div>

                        <span className="px-2 text-sm">حداقل مبلغ شارژ ۵۰،۰۰۰ تومان می باشد</span>


                        <div className="flex">
                            <div className="relative mt-4 w-[300px]">
                                <Input
                                    placeholder={"مبلغ را به تومان وارد کنید"}
                                    type="text"
                                    id={"price"}
                                    name={"price"}
                                    autoComplete={"off"}
                                    requiredir={true}
                                    value={price}
                                    onChange={handlePriceChange}
                                />
                            </div>
                        </div>

                        <div className="flex py-4">
                            <button
                                className="px-5 h-9 text-white bg-green-600 rounded-lg "
                                type="submit"
                                onClick={() => {
                                    if (price.length > 0) {
                                        const cleanedPrice = price.replace(/,/g, '');
                                        if (cleanedPrice < 50000) {
                                            toast.error("حداقل مبلغ شارژ ۵۰،۰۰۰ تومان می باشد")
                                        } else {
                                            const url = `${process.env.REACT_APP_SERVER}/api/billing/pay/${user._id}/${cleanedPrice}/${"discountCodeData"}`;
                                            window.location.href = url;
                                        }
                                    } else {
                                        toast.error("لطفا مبلغ را وارد کنید")
                                    }
                                }}
                            >
                                صدور صورتحساب
                            </button>
                        </div>

                    </div>
                ) : (
                    <PageChange />
                )}
            </Card>
        </>
    )
}

export default ReChargesAccountPage